import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import {
  AbsoluteWhiteColors,
  ControlColors,
} from '@picsart/design-system/foundation/colors';
import { Gradients } from '@picsart/design-system/foundation/gradients';

const useStyles = createUseStyles(
  {
    pill: {
      gap: Spacings.s4,
      height: Spacings.s32,
      borderRadius: CornerRadius.r24,
    },
    pillGold: {
      background: Gradients.status.warning,
      color: AbsoluteWhiteColors.base.default,
    },
    claimText: {
      fontSize: FontSizes.t4,
      fontWeight: FontWeights.semibold,
      color: ControlColors.text.active,
    },
    claimTextGold: {
      color: AbsoluteWhiteColors.base.default,
    },
  },
  { name: 'streak-pill' }
);

export default useStyles;
